import { render, staticRenderFns } from "./InventoryItemCatalog.vue?vue&type=template&id=c49103ee"
import script from "./InventoryItemCatalog.vue?vue&type=script&lang=js"
export * from "./InventoryItemCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports